import { render, staticRenderFns } from "./Question14.vue?vue&type=template&id=dcda1746&scoped=true&"
import script from "./Question14.vue?vue&type=script&lang=js&"
export * from "./Question14.vue?vue&type=script&lang=js&"
import style0 from "./Question14.vue?vue&type=style&index=0&id=dcda1746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcda1746",
  null
  
)

export default component.exports